<main class="c-main wow-consulta">
  <div class="container-fluid">
    <div class="row">
      <div class="alert alert-danger" role="alert" *ngFor="let erro of mensagemErros">
        {{ erro }}
      </div>
    </div>
    <div class="mat-elevation-z8">
      <mat-card>
        <div class="wow-consulta__header">
          <div class="wow-consulta__header-icon"><mat-icon>color_lens</mat-icon></div>
          <mat-card-title>Movimentação</mat-card-title>
        </div>

        <app-wow-consulta-filtros
          [tipoFiltros]="tipoFiltros"
          [(tipoFiltro)]="tipoFiltro"
          [(parametro)]="parametro"
          [showParametro]="tipoFiltro === 'ID'"
          [parametroMask]="'separator.0'"
          (tipoFiltroChange)="onFiltroChange()"
          (consultar)="consultar()"
          (novo)="novo()">

          <ng-container *ngIf="tipoFiltro === 'Período'">
            <div class="col-12 col-sm-6 col-md-4 col-lg-3">
              <mat-form-field appearance="fill" class="full-width">
                <mat-label>Início</mat-label>
                <input matInput [matDatepicker]="pickerInicio" [formControl]="dataInicio">
                <mat-datepicker-toggle matIconSuffix [for]="pickerInicio"></mat-datepicker-toggle>
                <mat-datepicker #pickerInicio></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="col-12 col-sm-6 col-md-4 col-lg-3">
              <mat-form-field appearance="fill" class="full-width">
                <mat-label>Fim</mat-label>
                <input matInput [matDatepicker]="pickerFim" [formControl]="dataFim">
                <mat-datepicker-toggle matIconSuffix [for]="pickerFim"></mat-datepicker-toggle>
                <mat-datepicker #pickerFim></mat-datepicker>
              </mat-form-field>
            </div>
          </ng-container>
        </app-wow-consulta-filtros>

        <div class="wow-consulta__empty" *ngIf="!consultaRealizada">
          Informe os filtros e clique em <strong>Consultar</strong>.
        </div>

        <ng-container *ngIf="consultaRealizada">
          <table mat-table [dataSource]="movimentacoes" class="full-width">
            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef>ID</th>
              <td mat-cell *matCellDef="let m">{{ m.id }}</td>
            </ng-container>
            <ng-container matColumnDef="contaOrigemDescricao">
              <th mat-header-cell *matHeaderCellDef>Conta Origem</th>
              <td mat-cell *matCellDef="let m">{{ m.contaOrigemDescricao }}</td>
            </ng-container>
            <ng-container matColumnDef="contaDestinoDescricao">
              <th mat-header-cell *matHeaderCellDef>Conta Destino</th>
              <td mat-cell *matCellDef="let m">{{ m.contaDestinoDescricao }}</td>
            </ng-container>
            <ng-container matColumnDef="valorMovimentacao">
              <th mat-header-cell *matHeaderCellDef>Valor</th>
              <td mat-cell *matCellDef="let m">{{ m.valorMovimentacao | currency:'BRL' }}</td>
            </ng-container>
            <ng-container matColumnDef="tipoMovimentacao">
              <th mat-header-cell *matHeaderCellDef>Tipo</th>
              <td mat-cell *matCellDef="let m">{{ m.tipoMovimentacao }}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="ordemColunasTabela"></tr>
            <tr mat-row *matRowDef="let row; columns: ordemColunasTabela;"></tr>
          </table>
          <mat-paginator [length]="totalElementos" [pageSize]="tamanho" [pageSizeOptions]="pageSizeOptions"
            (page)="paginar($event)"></mat-paginator>
        </ng-container>
      </mat-card>
    </div>
  </div>
</main>
